import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['themeType', 'dailyThemeFields', 'weeklyThemeFields'];

  typeChange(event) {
    if (this.themeTypeTarget.value === 'daily') {
      this.dailyThemeFieldsTarget.classList.remove('d-none');
      this.weeklyThemeFieldsTarget.classList.add('d-none');
    } else if (this.themeTypeTarget.value === 'weekly') {
      this.dailyThemeFieldsTarget.classList.add('d-none');
      this.weeklyThemeFieldsTarget.classList.remove('d-none');
    } else {
      this.dailyThemeFieldsTarget.classList.add('d-none');
      this.weeklyThemeFieldsTarget.classList.add('d-none');
    }
  }
}
